<template>
  <v-container>
    <taxFeeTypesUI />
  </v-container>
</template>

<script>
import taxFeeTypesUI from '../../components/shared/taxFeeTypes/taxFeeTypesList.vue';

export default {
  name: 'taxFeeTypes',
  components: {
    taxFeeTypesUI,
  },
};
</script>
